// Vendor imports
const { useSelector } = require('react-redux')
// Sibling imports
const selectors = require('./selectors')

function useIsSearchFormVisible() {
  return useSelector(selectors.isVisible)
}

module.exports = {
  useIsSearchFormVisible
}
